var map = {
	"./Logo-1.svg": "839a",
	"./Logo-2.svg": "58b5",
	"./Logo-3.svg": "6cd2",
	"./Logo-4.svg": "9df0",
	"./Logo-5.svg": "d8a8",
	"./Logo-6.svg": "f7a7",
	"./Logo-7.svg": "55ad",
	"./Logo-8.svg": "af81"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e13e";